export default "__VITE_ASSET__VxZAdToq__$_?url__"